import React, { useRef } from 'react';
import StyledButton from './styled-button';

export function PromotionInput(args: {
  onChange?: (data: string) => void;

  title?: string | React.ReactNode;
  hint?: string | React.ReactNode;
  disabled?: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div>
      {args?.title && (
        <label className="block font-medium text-gray-700">
          {args?.title}

          {args?.hint && (
            <span className="text-sm ml-1 text-gray-500">{args.hint}</span>
          )}
        </label>
      )}

      <div className="flex gap-2 relative items-center mt-1">
        <div className="relative block w-full shadow-xs">
          <input
            title="Promo"
            type="text"
            ref={inputRef}
            className="w-full rounded-md min-w-0 flex-1 border-brand-cashmere-500 focus:border-brand-pink focus:ring-brand-pink sm:text-sm"
            disabled={args?.disabled}
          />
        </div>

        <StyledButton
          type="button"
          design="default"
          className="text-center"
          onClick={() =>
            args.onChange && args.onChange(inputRef.current?.value ?? '')
          }
        >
          Speichern
        </StyledButton>
      </div>
    </div>
  );
}

export default PromotionInput;
